import { Outlet } from 'react-router';

import { useAtomValue } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useResetViewStateOnSectionLeave } from '@/hooks/useResetViewStateOnSectionLeave';

import { cn } from '@/utils/tailwind';

import { Header } from '@/components/header';

import { headerStateFamily } from '@/atoms/header';

export default function ExploreLayout() {
  useResetViewStateOnSectionLeave('/explore');
  const { nativeExploreWebView } = useFlags();
  const { title, backNavigation } = useAtomValue(headerStateFamily('explore'));

  const isNativeAndNativeWebViewFFEnabled =
    window.native.isNative && nativeExploreWebView;
  const shouldShowHeader = !isNativeAndNativeWebViewFFEnabled;

  return (
    <>
      {shouldShowHeader && (
        <Header.Root>
          <Header.Title>{title}</Header.Title>
          {backNavigation && (
            <Header.Back to={backNavigation.to}>
              {backNavigation.label}
            </Header.Back>
          )}
        </Header.Root>
      )}
      <div
        className={cn('centered-content', {
          'md:mt-header-height-with-content-spacing max-md:mt-header-content-spacing':
            shouldShowHeader,
        })}
      >
        <div className="px-4">
          <Outlet />
        </div>
      </div>
    </>
  );
}
